const CAPTION_PRESET_IDS = new Set([
  "classic",
  "bold-box",
  "light-box",
  "highlight",
  "pop",
  "soft"
]);

const CAPTION_SIZE_IDS = new Set(["normal", "large"]);
const CAPTION_POSITION_IDS = new Set(["lower", "center"]);
const CAPTION_CASING_IDS = new Set(["as-written", "upper"]);

export const CAPTION_STYLE_DEFAULTS = {
  preset: "classic",
  size: "normal",
  position: "lower",
  casing: "as-written"
};

export const CAPTION_PRESETS = [
  {
    id: "classic",
    label: "Classic",
    swatchClass: "social-post-page__caption-swatch--classic"
  },
  {
    id: "bold-box",
    label: "Bold box",
    swatchClass: "social-post-page__caption-swatch--bold-box"
  },
  {
    id: "light-box",
    label: "Light box",
    swatchClass: "social-post-page__caption-swatch--light-box"
  },
  {
    id: "highlight",
    label: "Highlight",
    swatchClass: "social-post-page__caption-swatch--highlight"
  },
  {
    id: "pop",
    label: "Pop",
    swatchClass: "social-post-page__caption-swatch--pop"
  },
  {
    id: "soft",
    label: "Soft",
    swatchClass: "social-post-page__caption-swatch--soft"
  }
];

export const CAPTION_SIZE_OPTIONS = [
  { id: "normal", label: "Normal" },
  { id: "large", label: "Large" }
];

export const CAPTION_POSITION_OPTIONS = [
  { id: "lower", label: "Lower" },
  { id: "center", label: "Center" }
];

export const CAPTION_CASING_OPTIONS = [
  { id: "as-written", label: "As written" },
  { id: "upper", label: "All caps" }
];

export const CAPTION_PREVIEW_SAMPLE = "Try this today";

export function normalizeCaptionStyle(value = {}) {
  const raw = value && typeof value === "object" ? value : {};
  const preset = String(raw.preset || CAPTION_STYLE_DEFAULTS.preset).trim().toLowerCase();
  const size = String(raw.size || CAPTION_STYLE_DEFAULTS.size).trim().toLowerCase();
  const position = String(raw.position || CAPTION_STYLE_DEFAULTS.position).trim().toLowerCase();
  const casing = String(raw.casing || CAPTION_STYLE_DEFAULTS.casing).trim().toLowerCase();

  return {
    preset: CAPTION_PRESET_IDS.has(preset) ? preset : CAPTION_STYLE_DEFAULTS.preset,
    size: CAPTION_SIZE_IDS.has(size) ? size : CAPTION_STYLE_DEFAULTS.size,
    position: CAPTION_POSITION_IDS.has(position) ? position : CAPTION_STYLE_DEFAULTS.position,
    casing: CAPTION_CASING_IDS.has(casing) ? casing : CAPTION_STYLE_DEFAULTS.casing
  };
}

export function getCaptionPreviewText(casing = CAPTION_STYLE_DEFAULTS.casing) {
  return casing === "upper"
    ? CAPTION_PREVIEW_SAMPLE.toUpperCase()
    : CAPTION_PREVIEW_SAMPLE;
}

export function getCaptionPresetLabel(presetId = CAPTION_STYLE_DEFAULTS.preset) {
  const preset = CAPTION_PRESETS.find((entry) => entry.id === presetId);
  return (preset && preset.label) || "Classic";
}

export function getCaptionStyleSummary(style = CAPTION_STYLE_DEFAULTS) {
  const normalized = normalizeCaptionStyle(style);
  const sizeEntry = CAPTION_SIZE_OPTIONS.find((entry) => entry.id === normalized.size);
  const sizeLabel = (sizeEntry && sizeEntry.label) || "Normal";
  return `${getCaptionPresetLabel(normalized.preset)} · ${sizeLabel}`;
}
